import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBox, faDollarSign } from '@fortawesome/free-solid-svg-icons';
import PlanManagementSimple from './PlanManagementSimple';
import PaymentRequests from './PaymentRequests';

const PlansAndPayments: React.FC = () => {
  const [activeTab, setActiveTab] = useState('plans');

  return (
    <div className="container mx-auto p-6">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-3xl font-bold flex items-center gap-2">
          <FontAwesomeIcon icon={faBox} className="text-gray-700" />
          Plans & Payments
        </h1>
        <p className="text-gray-600 mt-2">
          Manage subscription plans and one-time payment requests
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
        <TabsList className="grid w-full grid-cols-2 max-w-md">
          <TabsTrigger value="plans" className="flex items-center gap-2">
            <FontAwesomeIcon icon={faBox} className="w-4 h-4" />
            Subscription Plans
          </TabsTrigger>
          <TabsTrigger value="payments" className="flex items-center gap-2">
            <FontAwesomeIcon icon={faDollarSign} className="w-4 h-4" />
            One-Time Payments
          </TabsTrigger>
        </TabsList>

        <TabsContent value="plans" className="mt-0">
          <PlanManagementSimple />
        </TabsContent>

        <TabsContent value="payments" className="mt-0">
          <PaymentRequests />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default PlansAndPayments;